import {inject,Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CreateContactRequestRequestDto} from './dto/create-contact-request-request.dto';
import {CheckStringResponseDto} from '../common/dto/check-string-response.dto';
import {environment} from '../../environments/environment';

@Injectable({
	providedIn:'root'
})
export class ContactService{
	private readonly httpClient=inject(HttpClient);
	
	createContactRequest(data:CreateContactRequestRequestDto):Observable<CheckStringResponseDto>{
		return this.httpClient.post<CheckStringResponseDto>(
			`${environment.functions.contact}`,
			data
		);
	}
}
